import getCache from '../../cache/helpers/getCache';

export default (status) => {
  const appCache = getCache('app');
  if (appCache) {
    appCache.set({ isRealtimeOffline: status }, { setType: 'extend' });
  }
};
